import page from 'page'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, lifecycle} from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'
import { logOut } from '../store/reducers/auth'
import { uploadImage } from '../store/reducers/profile/uploadImage'
import { fetchingState } from './../helpers/hocs.js'
import { getIsLogged } from '../selectors/user.js'
import { getState, paidIsDone, requestMeet } from '../store/reducers/profile/info'
import { get as getPerson, getLots } from '../store/reducers/persons/info'
import { getTotalLotsSum } from '../selectors/person'
//import MainContainer from './Main'
//import Sidebar from '../components/PersonProfile/Sidebar'
import Overlay from '../components/Overlay'
import PersonFormProfile from '../components/PersonProfile/Form/PersonFormProfile'
import numeral from 'numeral'
import ProfileWrapper from '../components/PersonProfile/ProfileWrapper'
import Close from '../components/Icons/Close'


const PersonProfile = ({ showFormEventPopup, info, setFormEventPopup, lots, fixedpricelots, totalSum, setModalState, logOut, user, fetching, intl}) => {
  if (fetching.state && !user.person) return null

  return (
    <ProfileWrapper text="Заполните, пожалуйста, информацию для формирования карточки вашего лота" active="about" switch={{currentData: {}}}>
      <div className='person-profile'>
        <div className='person _additional-info items'>
          {!user.person.is.enabled && 
            <div className='item _person-warning' style={{marginBottom: "2vh"}}>
              <img className='image-warning' src={'/assets/img/person-warning.png'} alt='person-warning'/>
              <span className='text-warning'>
                Для участия в аукционах в качестве Героя, вам необходимо заполнить <a href={'/persondocuments'}>Согласие об обработке данных</a> в разделе «Документы».
              </span>
            </div>
          }
          {/* <div className='item _summary'>
            {(totalSum && totalSum.sum !== 0)
              ?
              <div className='person-info-donated'>
                <span>
                  <nobr>{numeral(totalSum.sum).format('0,0')} {totalSum.currency}</nobr>
                </span>
                <FormattedMessage id='person_about_me.summ_donated'/>
              </div>
              :
              <div className='person-info-donated'>
                <FormattedMessage id='person.summ_not_donated'/>
              </div>
            }
          </div> */}
          <div className='item'>
            <PersonFormProfile person={user.person} showCompleteMessage={setFormEventPopup}/>
          </div> 
        </div>
        <Overlay isActive={showFormEventPopup} klassModifier={"welcome-persone mfc-modal_4"}>
          {showFormEventPopup &&
            <div className='ProfileContainer__modal ProfileContainer__modal_red' style={{position: "relative"}}>
            <div className='ProfileContainer__modal-wrapper'>
              <div className='ProfileContainer__modal-header'>
                <p className='ProfileContainer__modal-header-title'>
                  Спасибо!
                </p>
              </div>
              <div className='ProfileContainer__modal-main' style={{paddingBottom: "80px"}}>
                Материалы переданы в работу менеджеру, который подготовит ваш лот. Когда карточка будет готова, вам придёт уведомление, и вы сможете согласовать материалы в личном кабинете
              </div>
            </div>
            <div className='ProfileContainer__modal-close' onClick={()=> setFormEventPopup(false)}><Close/></div>
          </div>
          }
        </Overlay>
      </div>
    </ProfileWrapper>

    // <div className='person-profile'>
    //   <div className='person _additional-info items'>
    //     {!user.person.is.enabled && 
    //       <div className='item _person-warning'>
    //         <img className='image-warning' src={'/assets/img/person-warning.png'} alt='person-warning'/>
    //         <span className='text-warning'>
    //           Для участия в аукционах в качестве Героя вам необходимо заполнить
    //           <a href={'/persondocuments'}> Согласие об обработке данных</a> в разделе «Документы».
    //         </span>
    //       </div>
    //     }
    //     <div className='item _summary'>
    //       {(totalSum && totalSum.sum !== 0)
    //         ?
    //         <div className='person-info-donated'>
    //           <span>
    //             <nobr>{numeral(totalSum.sum).format('0,0')} {totalSum.currency}</nobr>
    //           </span>
    //           <FormattedMessage id='person_about_me.summ_donated'/>
    //         </div>
    //         :
    //         <div className='person-info-donated'>
    //           <FormattedMessage id='person.summ_not_donated'/>
    //         </div>
    //       }
    //     </div>
    //     <div className='item'>
    //       <PersonFormProfile person={user.person} showCompleteMessage={setFormEventPopup}/>
    //     </div> 
    //   </div>
    //   <Overlay isActive={showFormEventPopup} onClose={()=> setFormEventPopup(false)} klassModifier='is--blured'>
    //     {showFormEventPopup &&
    //       <div className='SavePopup-data'>
    //         <h1 className='EmailPopup-h1 EmailPopup-h1-connection'><FormattedMessage id='person_profile.save' /></h1>
    //       </div>
    //     }
    //   </Overlay>
    // </div>
  )
}

const mapStateToProps = state => ({
  //user: getLoggedUser(state),
  //images: state.images,
  isLogged: getIsLogged(state),
  totalSum: getTotalLotsSum(state),
  //...state.profile.info,
  //...state.persons.info,
  //...state.images,
})

const mapDispatchToProps = dispatch => bindActionCreators({ getState, getLots, getPerson, logOut, paidIsDone, requestMeet, uploadImage }, dispatch)
const mergeProps = (state, {paidIsDone, getState, getPerson, getLots, requestMeet, logOut}, props) => ({
  ...props,
  ...state,
  logOut,
  getPerson: async (id) => {
    let memberId = id || props.user.person._id;
    let result = await props.fetchingWrap(getPerson.bind(this, memberId), 'info')
    if (result === 200) {
      //получение суммы собранных средств
      await getLots(memberId)
    } else props.on404()
  },
})

export default injectIntl(compose(
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withState('showFormEventPopup', 'setFormEventPopup', false),
  withState('modalState', 'setModalState', {}),
  withHandlers({
    setModalState: ({ setModalState, modalState }) => (name, state, e) => {
      e && e.preventDefault()
      if ([ 'claim', 'edit', 'report' ].indexOf(name) === -1) return
      modalState[name] = state || false
      setModalState(modalState)
    },
  }),
  lifecycle({
    componentWillUnmount () {
      //this.props.setImages({})
    },
    componentWillMount () {
      if (!this.props.isLogged) this.props.on404()
      else {
        this.props.getPerson()
      }
    },
    componentWillReceiveProps (np) {
      if (this.props.isLogged && !np.isLogged) page('/')
    }
  })
)(PersonProfile))


// WEBPACK FOOTER //
// ./src/containers/PersonProfile.jsx